var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 100,
    viewBox: "0 0 150 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.315 30.0004C72.9535 30.0068 71.6533 30.1227 70.5095 30.3252C67.1393 30.9209 66.5277 32.1669 66.5277 34.4649V37.5001H74.4912V38.5117H63.5352C61.2206 38.5117 59.1939 39.9031 58.5606 42.5493C57.8295 45.5827 57.7969 47.4758 58.5606 50.6432C59.1269 53.0012 60.4788 54.6808 62.7931 54.6808H65.5314V51.0425C65.5314 48.4136 67.8055 46.0951 70.5059 46.0951H78.4606C80.6748 46.0951 82.4423 44.2718 82.4423 42.0479V34.4645C82.4423 32.3062 80.6216 30.6847 78.4606 30.3248C77.0927 30.0972 75.673 29.9937 74.3115 30L74.315 30.0004ZM70.0046 32.441C70.8271 32.441 71.499 33.1239 71.499 33.9632C71.499 34.8 70.8271 35.4761 70.0046 35.4761C69.1791 35.4761 68.5101 34.7996 68.5101 33.9632C68.5101 33.1235 69.1788 32.441 70.0046 32.441Z",
    fill: "url(#paint0_linear_3785_11637)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4437 38.512V42.0485C83.4437 44.7905 81.1191 47.0977 78.4691 47.0977H70.5145C68.3357 47.0977 66.5327 48.9628 66.5327 51.1449V58.7286C66.5327 60.8869 68.4094 62.1563 70.5145 62.7758C73.0319 63.5168 75.4528 63.6509 78.4691 62.7758C80.4742 62.1953 82.4509 61.027 82.4509 58.7286V55.6934H74.4962V54.6818H86.4326C88.7472 54.6818 89.6095 53.0674 90.4144 50.6442C91.2459 48.1494 91.2104 45.7503 90.4144 42.5503C89.8425 40.2462 88.7501 38.5127 86.4326 38.5127H83.4437V38.512ZM78.9698 57.717C79.7952 57.717 80.4643 58.3935 80.4643 59.23C80.4643 60.0696 79.7956 60.7522 78.9698 60.7522C78.1472 60.7522 77.4753 60.0693 77.4753 59.23C77.4753 58.3932 78.1472 57.717 78.9698 57.717Z",
    fill: "url(#paint1_linear_3785_11637)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.444,
    d: "M85.2553 67.9302C85.2553 69.073 80.4772 69.9998 74.5832 69.9998C68.6892 69.9998 63.9111 69.0733 63.9111 67.9302C63.9111 66.7871 68.6892 65.8606 74.5832 65.8606C80.4772 65.8606 85.2553 66.7871 85.2553 67.9302Z",
    fill: "url(#paint2_radial_3785_11637)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3785_11637",
    x1: 58.0029,
    y1: 29.9997,
    x2: 76.2186,
    y2: 45.8224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A9FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#306998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3785_11637",
    x1: 78.7748,
    y1: 58.9747,
    x2: 72.2699,
    y2: 49.6828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD43B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE873"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3785_11637",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5833 67.9301) rotate(-90) scale(2.06951 9.09602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B8B8",
    stopOpacity: 0.498
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7F7F",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.625fd1ae4b8f78da3e40e1845a501404.svg";
export { ForwardRef as ReactComponent };